import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NzConfigService } from 'ng-zorro-antd/core/config';

registerLocaleData(es);
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],

  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  title = 'core-fluens';

  constructor(
    private readonly nzConfigService: NzConfigService
  ) {
    // Add multiple icons to the library

    this.nzConfigService.set('dropDown', { nzBackdrop: true });
  }

  ngOnInit(): void {
  }

}
